module.exports = __webpack_public_path__ + "img/bgtop2.a26b1745.jpg";